module.exports = __webpack_public_path__ + "img/Bullseye-Gradient.f16e8371.svg";